import device from "current-device";
import { DeviceType } from "Types/api/Tracking";

export function getDeviceType(): DeviceType {
    return device.mobile() ? "mobile" : "desktop";
}
